var _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadCrumbs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 8,
    viewBox: "0 0 31 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 0 5.89844)",
    fill: "#727272"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 11.4922 5.89844)",
    fill: "#727272"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 22.9844 5.89844)",
    fill: "#727272"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5547 1L9.00177 6.79555",
    stroke: "#727272",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0469 1L20.494 6.79555",
    stroke: "#727272",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadCrumbs);
export default __webpack_public_path__ + "static/media/bread_crumbs.b85a81a122ad417e914a0abec40a8bcd.svg";
export { ForwardRef as ReactComponent };